import { useEffect, useState } from 'react';
import { collection, query, where, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase/config';
import { COLLECTIONS } from '../firebase/collections';
import { useAuth } from '../context/AuthContext';
import { sanitizeProductionTask } from '../utils/labour';

export function useActiveTask() {
  const { user, companyId } = useAuth();
  const [activeTasks, setActiveTasks] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user || !companyId) { setLoading(false); return; }

    const q = query(
      collection(db, COLLECTIONS.PRODUCTION_TASKS),
      where('companyId', '==', companyId),
      where('createdBy', '==', user.uid),
      where('status', '==', 'active'),
    );

    const unsub = onSnapshot(
      q,
      (snap) => {
        setActiveTasks(snap.docs.map((d) => sanitizeProductionTask({ id: d.id, ...d.data() })));
        setLoading(false);
      },
      (err) => {
        console.error('useActiveTask:', err);
        setLoading(false);
      },
    );

    return unsub;
  }, [user, companyId]);

  return { activeTasks, activeTask: activeTasks[0] ?? null, loading };
}
